export default __webpack_public_path__ + "static/1-56904e9bb5ba23c184388c1dceea893f.png";